export default {"src":"/_next/static/media/defaultCompany.e789b823.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};